export default "__VITE_ASSET__CJfRc3dq__"